import * as API from "../api"

export const FETCH_AREAS = "FETCH_AREAS"
export const FETCHING_AREAS = "FETCHING_AREAS"
export const FETCH_AREAS_ERROR = "FETCH_AREAS_ERROR"

const handleAreas = areas => {
  return areas.map(area => (
      { 
        value: area.id,
        code: area.code,
        label: area.code ?  `${area.code} - ${area.name}` : area.name, 
        areaResponsible: area.responsible, 
        businessUnitResponsible: area.businessUnitResponsible 
      }
  ));
}

export const fetchAreas = (text) => {
  return dispatch => {
    dispatch({ type: FETCHING_AREAS, value: true });

    return new Promise((resolve, reject) => {
      API.area
        .getAreas(text)
        .then(response => {
          const areas = handleAreas((response || {}).data || [])

          dispatch({
            type: FETCH_AREAS,
            items: areas,
            last_update: ((response || {}).data || {}).last_update,
          });

          resolve(areas)
        })
        .catch(err => {
          dispatch({ type: FETCH_AREAS_ERROR });
          reject(err)
        });
    })
  };
};



// WEBPACK FOOTER //
// ./src/actions/area.js